module.exports = __webpack_public_path__ + "img/goods-mobile-5.5d4ed76a.png";